import { ReactNode } from "react";
import { useEscapeToClose } from "../../Hook/dismiss";

/**
 * The bottom-sheet scaffold (fix docket CL3), extracted from the three copies
 * that had already drifted apart: scrim, slide-in, grab handle, safe-area
 * padding — and the desktop stance, where an edge-anchored drawer reads as a
 * mistake, so the same panel centres at popin width instead.
 *
 * Content is the caller's; FilterSheet composes its header/footer on top, the
 * gift sheet its steps. `zClass` exists for the one sanctioned exception — the
 * gift sheet deliberately sits at z-sheet-low so the tokens popin can cover it.
 */
function Sheet({
  onClose,
  children,
  testId,
  zClass = "z-sheet",
  desktopCentered = true,
}: {
  onClose: () => void;
  children: ReactNode;
  testId?: string;
  zClass?: string;
  /** Rarely off — a sheet that must stay edge-anchored on desktop opts out. */
  desktopCentered?: boolean;
}) {
  useEscapeToClose(onClose);

  return (
    <div
      className={
        "fixed inset-0 flex flex-col justify-end " +
        zClass +
        (desktopCentered ? " desktop:justify-center desktop:items-center" : "")
      }
      role="dialog"
      aria-modal="true"
      data-testid={testId}
    >
      <div className="absolute inset-0 bg-tint-overlay" onClick={onClose} />

      <div
        className={
          "s4s-sheet relative w-full bg-panel rounded-t-sheet shadow-sheet px-sheet-padding-x pt-sheet-padding-top pb-sheet-padding-bottom max-h-[85vh] flex flex-col" +
          (desktopCentered
            ? " desktop:max-w-[560px] desktop:rounded-sheet desktop:max-h-[80vh]"
            : "")
        }
      >
        <div className="w-grab-handle-width h-grab-handle-height rounded-pill bg-tint-grab-handle mx-auto mb-3.5 flex-none" />
        {children}
      </div>
    </div>
  );
}

export default Sheet;
